import { AxiosResponse } from "axios";

import instance from "../instance";
import { SearchParams, SearchInterface } from "@/core/reatom/state/search";

export const getSearch = async (
  params: SearchParams
): Promise<SearchInterface> => {
  const res: AxiosResponse<SearchInterface> = await instance.get(
    "/v1/uslugi-freelancera/search",
    { params: { ...params, user_form_types: [1, 3] } }
  );
  return res.data;
};
